export default [{
		path: '/admin',
		redirect: '/syslogin',
	}, {
		path: '/syslogin',
		component: () => import('../sys/login'),
		meta: {
			title: '后台管理-登录'
		}
	}, {
		path: '/sys',
		component: () => import('../sys/home'),
		redirect: '/sys/index',
		children: [{
				path: 'index',
				component: () => import('../sys/index'),
				meta: {
					title: '后台管理-主页'
				}
			},
			//组织架构管理
			{
				path: 'org',
				component: () => import('../sys/org/index'),
				redirect: '/sys/org/school',
				children: [{
						path: 'school',
						component: () => import('../sys/org/school'),
						meta: {
							title: '（学校管理）后台管理'
						}
					},
					{
						path: 'dept',
						component: () => import('../sys/org/dept'),
						meta: {
							title: '（学院管理）后台管理'
						}
					},
					{
						path: 'major',
						component: () => import('../sys/org/major'),
						meta: {
							title: '（专业管理）后台管理'
						}
					},
					{
						path: 'class',
						component: () => import('../sys/org/class'),
						meta: {
							title: '（班级管理）后台管理'
						}
					},
				]
			},
			//用户管理
			{
				path: 'user',
				component: () => import('../sys/user/index'),
				redirect: '/sys/user/student',
				children: [{
						path: 'school',
						component: () => import('../sys/user/school')
					},
					{
						path: 'dept',
						component: () => import('../sys/user/dept')
					},
					{
						path: 'student',
						component: () => import('../sys/user/student')
					},
					{
						path: 'teacher',
						component: () => import('../sys/user/teacher')
					}
				]
			},
			//产品管理
			{
				path: 'product',
				component: () => import('../sys/product/index'),
				redirect: '/sys/product/product',
				children: [{
						path: 'product',
						component: () => import('../sys/product/product'),
						meta: {
							title: '产品管理'
						}
					},
					{
						path: 'category',
						component: () => import('../sys/product/category'),
						meta: {
							title: '产品分类管理'
						}
					},
					{
						path: 'modelcategory',
						component: () => import('../sys/product/modelcategory')
					},
					{
						path: 'model',
						component: () => import('../sys/product/model'),
						meta: {
							title: '产品模块管理'
						}
					}
				]
			},
			// 产品资源管理
			{
				path: 'productResource',
				component: () => import('../sys/productResource/index'),
				redirect: '/sys/productResource/product',
				children: [{
						path: 'type',
						component: () => import('../sys/productResource/type')
					},
					{
						path: 'resource',
						component: () => import('../sys/productResource/list')
					}
				]
			} 
		]
	}
]